import Plyr from 'plyr';

class PlyrEma {
  constructor() {
    this.video()
  }

  video () {
    try {
      const player = new Plyr('#player');
    } catch (error) {
      console.log('PlyrEma.video', {message: error.message});
    }
  }
}

export default window.addEventListener('DOMContentLoaded', () => {
  new PlyrEma()
})